import {EQDepartment} from "../EQDepartment";
import {EQUser} from "../EQUser";
import {EQWorkOrder} from "./EQWorkOrder";

export interface EQChangeRequest {
  // ---------------- DB Properties
  uid: number;
  guid: string;
  companyUID: number;
  requesterUID: number;
  serialNo: number; // 일련번호
  requestDate: Date | string; // 발의 일자
  type: number; // 변경구분  0 - 정상변경, 1 - 임시변경, 2 - 비상변경
  content: string; // 변경 내용
  status: number; // 상태  0 - 진행, 1 - 완료, 2 - 반려, 3 - 지연
  statusContent: string; // 반려/지연 사유
  level: string; // 변경등급
  attachmentFileName: string; // 변경검토근거자료 파일명
  extension: string; // 변경검토근거자료 확장자
  attachmentGUID: string; // Deprecated 필요없음 - GUID로 대체
  entryDate: Date | string;

  estimateDate: Date | string; // 복구예정일
  completeDate: Date | string; // 완료일

  isDeleted: boolean;
  requestFile: string; // 변경요구서

  hasProcessSafety: boolean; // 공정안전자료 여부
  hasProcessEval: boolean; // 공정위험성평가 여부
  hasSafetyProcedure: boolean; // 안전운전절차 여부
  hasEmergency: boolean; // 비상조치계획 여부
  hasEducation: boolean; // 근로자교육 여부

  processSafetyFile: string; // 공정안전자료 파일명
  processFile: string; // 공정위험성평가 파일명
  procedureFile: string; // 안전운전절차 파일명
  emergencyFile: string; // 비상조치계획 파일명
  educationFile: string; // 근로자교육평가 파일명
  preCheckFile: string; // 가동전점검 파일명

  // --------------- Non DB Properties
  base64Attachment: string; // 변경검토근거자료
  base64Request: string; // 변경요구서
  base64ProcessSafety: string; // 공정안전자료
  base64Process: string; // 공정위험성평가
  base64Procedure: string; // 안전운전절차
  base64Emergency: string; // 비상조치계획
  base64Education: string; // 근로자교육평가
  base64PreCheck: string; // 가동전점검

  // NOT DB
  requester: EQUser; // 발의자
  department: EQDepartment; // 발의자의 부서
  serialString: string; // 일련번호 문자열
}

export interface changeRequestListParams {
  page: number;
  token: string;
  rows?: number;
  departmentUID: number; // 작성부서 UID (-1은 전체)
  userName: string; // 작성자 명
  type: number; // 변경구분 0 - 정상변경, 1 - 임시변경, 2 - 비상변경 (-1은 전체)
  content: string; // 변경 내용
  startDate: Date | string | null;
  endDate: Date | string | null;
}

export const initializeChangeRequestListParams: changeRequestListParams = {
  page: 1,
  token: "",
  rows: 20,
  departmentUID: -1,
  type: -1,
  userName: "",
  content: "",
  startDate: null,
  endDate: null,
};
export const initializeChangeRequest = (type: number = 0): EQChangeRequest => {
  return {
    uid: 0,
    guid: "00000000-0000-0000-0000-000000000000",
    companyUID: 0,
    requesterUID: 0,
    status: 0,
    requestDate: new Date(),
    type: 0,
    serialNo: 0,
    content: "",
    statusContent: "",
    level: "",
    attachmentFileName: "",
    extension: "",
    attachmentGUID: "00000000-0000-0000-0000-000000000000",
    entryDate: new Date(),

    estimateDate: new Date(),
    completeDate: new Date(),

    isDeleted: false,

    hasProcessSafety: false,
    hasProcessEval: false,
    hasSafetyProcedure: false,
    hasEmergency: false,
    hasEducation: false,

    requestFile: "",
    processSafetyFile: "",
    processFile: "",
    procedureFile: "",
    emergencyFile: "",
    educationFile: "",
    preCheckFile: "",

    base64Attachment: "",
    base64Request: "",
    base64ProcessSafety: "",
    base64Process: "",
    base64Procedure: "",
    base64Emergency: "",
    base64Education: "",
    base64PreCheck: "",

    requester: {} as EQUser,
    department: {} as EQDepartment,
    serialString: "",
  };
};

export const changeStatusNames = ["진행", "완료", "반려", "지연"];
export const changeTypeNames = ["정상변경", "임시변경", "비상변경"];

export const getChangeNo = (workOrder: EQWorkOrder) => {
  if (!workOrder.changeRequest || workOrder.changeRequest.uid === 0) {
    return "";
  }
  let changeNo =
    new Date(workOrder.changeRequest.requestDate).getFullYear() +
    "변경-" +
    workOrder.changeRequest.department.name +
    "-" +
    workOrder.changeRequest.serialNo.toString().padStart(4, "0");
  return changeNo;
};
